module.exports = __webpack_public_path__ + "img/right.48d334ae.svg";